import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth32: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M82.6,355.3l1.7,11.7,5.5,29.2,4.9,35.8,2.5,32.4-1.9,3.6-4.1,2.2-5.8,1.3-6.1.6s-3.9-.3-4.4-.2-2,.5-2,.5l-8.5,1.4-3.2.2-11.2-.5-4.6-1.6-4.1-.5-3.9-.9h-5.7l-4.9.2-3.3-1.7-2.8-1.9-1.9-3.5-.8-3.6.9-19.4,1.9-16.4,4.6-30.6,7.4-37.4,1-4.8s22.4-13.7,48.8,3.9Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.8,351.4s23.4-13.2,48.8,3.9l-1-5.5s-24.3-16.4-47.1-3l-.7,4.7Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M66.6,378.7a8.2,8.2 0 1,1 -16.4,0a8.2,8.2 0 1,1 16.4,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.3,375.6l-6.3,43.8s51.1-16,6.3-43.8Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.4,375.7l7.5,42.5s-52.6-14.3-7.5-42.5Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.9,356.2l-3.6,19.4-6.3,43.8-4.2,29.5v14.2l1.5,3,2.5,2.3,4.5,1.5,3.7.7,3.8.2,7.8,1.3,7.8,1s9.8-94.3-17.7-116.8Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M83,357.5l3.4,18.2,7.5,42.5,3.9,28.7.5,17.9-2.3,4.2-5,3-10.5.8-15.2.8s-6.3-100.2,17.7-116Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M82.6,355.3l1.7,11.7,5.5,29.2,4.9,35.8,2.5,32.4-1.9,3.6-4.1,2.2-5.8,1.3-6.1.6s-3.9-.3-4.4-.2-2,.5-2,.5l-8.5,1.4-3.2.2-11.2-.5-4.6-1.6-4.1-.5-3.9-.9h-5.7l-4.9.2-3.3-1.7-2.8-1.9-1.9-3.5-.8-3.6.9-19.4,1.9-16.4,4.6-30.6,7.4-37.4,1-4.8s22.4-13.7,48.8,3.9Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98.2,448.9l.3,15-2.6,5.1-8.7,3.2-12.9.5-15.9,2.5-18.9-3.7h-8.7l-8.5-2.8-4.1-5.5.7-14.4s80.3-.9,79.3.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'21.2 424 30.4 413.8 32.7 430.5 40 410.6 45.4 430.5 52.2 409.5 58.4 429.3 65.3 409.5 71.2 429.6 77.7 409.5 82.8 429 86.5 413 94.1 424.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'62.9 146.1 57.2 158 62.4 163.3 56.8 168.9 62.2 174.3 56.5 180 61.8 185.3 56.3 190.7 62 196.4 56.5 202 61.9 207.4 56.7 212.6 62.6 218.5 57.1 224.1 62.1 229.1 56.2 235.1 61.6 240.5 56.4 245.8 62 251.3 56.9 256.3 62.5 262 57.3 267.2 62.1 272.1 57.8 276.4 62.7 281.3 58.1 285.9 63 290.8 58.1 295.7 62.7 300.3 58.2 304.8 62.8 309.4 57.2 315.1 62 319.8 57.1 324.7 62 329.7 56.5 335.1 61.7 340.3 55.8 346.3 60.8 351.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'43.4 255.7 46.8 250.5 50.1 255.8 54.1 250 58.1 255.8 61.4 249.8 65.1 254.8 68.2 250.5 70.8 255.2 73.2 250 75.3 254.9',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '31.3 91 44.1 72.2 52.6 64 60.1 61.7 68.8 63.4 71.1 65.2 78.8 72.7 91.1 91.5 97.2 92.6 102.1 95.2 105.1 99.2 105.3 102.9 103.9 109.1 99.7 114.5 94.8 119.6 83.1 133.7 79.3 137.2 74.9 140.2 69.2 142.1 53.5 142.6 42.8 139.5 37.4 135.6 32.2 129.7 27.1 122.6 23.7 117.3 20.9 113.3 18.9 108.4 17.4 104.8 17.5 99.4 19.5 95.5 23.8 92.6 29.2 92.4 31.3 91',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.1,126.2h34.7s-16.5,20.3-34.7,0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.3,92.2l-6.5,1-4.2,3.9-1.3,2.5v6.2c-.1,0,2.3,5.9,2.3,5.9l4.9,6.2s39.3-14,4.8-25.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M90.7,91.5l7.7,1.3,5.5,3.5,2.6,4.3-.3,5.2-4.3,7.2-2.3,2.6s-39.7-11.3-8.8-24.1Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '30.2 91.7 22.8 93.2 18.6 97.1 17.3 99.6 17.2 105.8 19.7 111.7 24.6 117.9 97.5 117.7 101.9 113.2 106.2 105.8 106.5 100.6 103.9 96.3 98.4 92.8 90.7 91.5 30.2 91.7',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.3,102.9l-1.4,6.2-4.2,5.4-4.9,5.1-11.7,14.1-8.2,6.5-5.7,1.9-15.7.5-10.7-3.1-5.4-3.9-5.2-5.9-5.1-7.1-3.4-5.3-2.8-4-2-4.9-1.5-3.6s51.9,17.6,87.9-1.9Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17.4,104.8v-5.4c.1,0,2.1-3.9,2.1-3.9l4.3-2.9,5.4-.2,2.1-1.4,12.8-18.8,8.5-8.2,7.5-2.3,8.7,1.7,2.3,1.8,7.7,7.5,12.3,18.8,6.1,1.1,4.9,2.6,3,4,.2,3.7s-28.9,19.4-87.9,1.9Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'20 100.9 30.4 112.4 32.9 93.6 41 116 47.2 93.6 54.8 117.2 61.8 95 69.4 117.2 76.1 94.7 83.4 117.2 89 95.3 93.2 113.2 101.6 100.3',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.2,174.9l-10.9-61.3-5-43.8.4-19.7.6-4.3,5.4-4,10-.8,21.4-5.4,19.6,1.2,14.3.6,6.7,1.1,7.3,5.6,1.6,4.1-.4,20-1.9,11-1.8,16.5-3.2,18.7-1.8,11.2-2.5,13.3-5.6,18.5-1,8.9-1.1,8.7c-30.9,23.7-52.1-.2-52.1-.2Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.2,174.9s21.3,23.9,52.1.2l-.7,7.6s-24.3,19.7-50.6,0l-.8-7.8Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17.3,68l6.1,51.5s50.6-44.3-6.1-51.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M103.8,68l-7.1,49.5s-46.3-40.9,7.1-49.5Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36,118.6h48.4s-22.4,119.5-48.4,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '17 47.3 25.9 41.4 34.2 40.4 54.6 35.7 64.6 35.5 81 37.9 90.9 37.5 97 39.2 104.8 46.9 104.9 62.1 17.2 62.1 17 47.3',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.6,170.8l-8-42.7-4-30.5-3.6-27.7,1.4-24.1,7.6-5,9.2-.4,17.1-3.6s5.2,85.7-19.7,134Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M68.3,36.4l14,1.8,7.8-.6,7,1.8,6.6,6.8,1.2,8.8-3,29.7-6.6,42.3-7.4,29.7-1.8,8.2-.2,2.2s-21.1-75.8-17.7-130.8Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.2,174.9l-10.9-61.3-5-43.8.4-19.7.6-4.3,5.4-4,10-.8,21.4-5.4,19.6,1.2,14.3.6,6.7,1.1,7.3,5.6,1.6,4.1-.4,20-1.9,11-1.8,16.5-3.2,18.7-1.8,11.2-2.5,13.3-5.6,18.5-1,8.9-1.1,8.7c-30.9,23.7-52.1-.2-52.1-.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'20 92.5 30.1 105.5 32.6 84.3 40.5 109.6 46.5 84.3 53.8 110.8 60.7 85.9 68 110.8 74.6 85.6 81.6 110.8 87 86.1 91.1 106.4 99.3 91.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'60.6 373.6 66.3 361.6 60.9 356.4 66.5 350.7 61.1 345.4 66.7 339.6 61.3 334.4 66.7 328.9 61 323.2 66.5 317.6 61 312.3 66.2 307 60.2 301.1 65.6 295.5 60.5 290.6 66.4 284.5 60.9 279.1 66.1 273.9 60.5 268.4 65.5 263.3 59.8 257.7 65 252.4 60.1 247.6 64.4 243.2 59.4 238.4 64 233.7 59 228.9 63.9 223.9 59.2 219.3 63.6 214.8 59 210.2 64.5 204.6 59.7 199.8 64.6 194.9 59.6 190 65.1 184.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'42.9 264.8 46.7 270.6 50.4 264.7 54.8 271.1 59.3 264.7 63 271.4 67.1 265.8 70.5 270.6 73.4 265.4 76.1 271.1 78.4 265.6',
			],
		},
	},
};
